<div class="filter" fxLayout="row" fxLayout.xs="column" *ngIf="filterData" [ngClass]="{ hide: !expanded }">
    <div fxFlex="80px" fxFlex.xs="100" class="sampletype-selector">
        <div fxLayout="column">
            <div class="st-icon" [ngClass]="{ active: isActive('sampleType', sampleType.id) }"
                (click)="userSwitchSampleType(sampleType, true)"
                *ngFor="let sampleType of filterData.filterValues.sampleType" appHelpContent
                [helpContent]="sampleType.value">
                <img src="{{ getSampleTypeIcon(sampleType.id) }}" alt="{{ sampleType.value }}" />
            </div>
        </div>
    </div>
    <div fxFlex fxFlex.xs="100" class="filter-panel">
        <div class="toggle-button collapse" [ngClass]="{ show: expanded }" (click)="toggleFilterPanel()"></div>
        <div fxLayout="column" fxFlex>
            <div fxFlex>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <h4 class="filter-title" fxFlex>
                        {{ selectedSampleType.value }}
                        <span class="help" appHelpContent [helpContent]="helpContent['sampleTypes']">?</span>
                    </h4>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <h6 class="filter-title" fxFlex>
                        Area type and areas
                        <span class="help" appHelpContent [helpContent]="helpContent['shapeTypes']">?</span>
                    </h6>
                    <span (click)="resetAll(true)" class="reset" fx-layout-align="end">Reset</span>
                </div>
                <div class="filter-group" fxLayout="row">
                    <div class="shape-type" [ngClass]="{
                            active: isActive('shapeType', shapeType.id)
                        }" (click)="userSwitchShapeType(shapeType)" *ngFor="
                            let shapeType of filterData.filterValues.shapeType
                        " fxFlex>
                        {{ shapeType.value }}
                    </div>
                </div>
                <div class="filter-group" fxLayout="column">
                    <div class="filter-value-selection" (click)="showPopup(seaAreaFilter)">
                        Area
                    </div>
                    <div class="count-wrapper">
                        <span class="count" (click)="showPopup(seaAreaFilter)">{{ getCount('seaAreas') }}</span>
                    </div>
                    <div class="help-wrapper">
                        <span class="help" appHelpContent [helpContent]="helpContent['seaAreas']">?</span>
                    </div>
                </div>
                <div fxLayout="row">
                    <h6 class="filter-title" fxFlex>Filter settings</h6>
                    <!--<span (click)="resetFilters()" class="reset" fx-layout-align="end">Reset</span> -->
                </div>
                <div *ngFor="let item of filters">
                    <ng-container [ngTemplateOutlet]="item.tp"
                        [ngTemplateOutletContext]="{ item: item }"></ng-container>
                </div>
                <!-- <div #depthSlider class="filter-group" fxLayout="column">
          <h6>asd</h6>
          <div multiHandleRangeSlider [(defaultValues)]="defaultValues" [(relevantValues)]="relevantValues"
            [(oldSelectionValues)]="oldSelectionValues" [(newSelectionValues)]="newSelectionValues" name="range-slider" (onSlidingEvent)="applySliderValue($event)"></div>
        </div> -->
            </div>
        </div>
    </div>
</div>

<div class="toggle-button expand show" *ngIf="!expanded" (click)="toggleFilterPanel()"></div>

<div class="data-export" appDraggable [ngClass]="{ float: !expanded }" fxLayout="column">
    <!-- <span>&#10021;</span> -->
    <span class="count-label">Found <b>{{ sampleCount }}</b> samples</span>
    <span class="count-label">Found <b>{{ measureCount }}</b> measurements</span>
    <a class="btn btn-primary" (click)="openDialog()">Download selected data</a>
</div>

<div fxLayout="row" fxLayout.xs="column" *ngIf="!filterData" class="filter-skeleton filter">
    <div fxFlex="80px" fxFlex.xs="100" class="sampletype-selector">
        <div fxLayout="column">
            <div class="sk-sampletype" *ngFor="let i of [].constructor(4)"></div>
        </div>
    </div>
    <div fxFlex="400px" fxFlex.xs="100" class="filter-panel">
        <div fxLayout="column" fxFlex>
            <div class="sk-filter-title"></div>
            <div class="filter-group" fxFlex>
                <div class="sk-filter-label"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-label"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
                <div class="sk-filter-content"></div>
            </div>
            <div class="sk-data-export"></div>
        </div>
    </div>
</div>

<div id="loading" *ngIf="showSpinner">
    <div class="container">
        <svg viewBox="0 0 100 100">
            <defs>
                <filter id="shadow">
                    <feDropShadow dx="0" dy="0" stdDeviation="1.5" flood-color="#3561ce" />
                </filter>
            </defs>
            <circle class="spinner" style="
                    fill: transparent;
                    stroke: #3561ce;
                    stroke-width: 7px;
                    stroke-linecap: round;
                    filter: url(#shadow);
                " cx="50" cy="50" r="45" />
        </svg>
    </div>
</div>

<div class="modal-box" *ngIf="showModal" appDraggable>
    <div fxLayout="column" fxFlexFill>
        <div fxLayout="column" fxFlex="100px" class="modal-header">
            <div fxLayout="row">
                <h6 class="modal-title">{{ modalTitle }}</h6>
            </div>
            <div fxLayout="row" fxFill>
                <div class="modal-toolbar" fxLayout="row" fxFlex="calc(100% - 180px)" fxLayoutAlign="start start">
                    <span (click)="selectUnselectAll(modalBoxFilterValues, true)" class="tool-container">
                        <span>Select All </span>
                    </span>
                    <span (click)="selectUnselectAll(modalBoxFilterValues, false)" class="tool-container">
                        <span>Unselect All </span>
                    </span>
                    <span (click)="expandAll(modalBoxFilterValues)" *ngIf="modalBoxFilterValues.parentChild"
                        class="tool-container">
                        <span><i class="fas fa-angle-down"></i> Expand All</span>
                    </span>
                    <span (click)="collapseAll(modalBoxFilterValues)" *ngIf="modalBoxFilterValues.parentChild"
                        class="tool-container">
                        <span><i class="fas fa-angle-up"></i> Collapse All</span>
                    </span>
                    <input type="text" class="filter-q" placeholder="Search..." (input)="q($event.target.value)"
                        #messageInput />
                </div>
                <div class="modal-buttons" fxLayout="row" fxFlex="180px" fxLayoutAlign="end start">
                    <a class="cancel" (click)="hidePopup()">Cancel</a>
                    <a class="btn btn-primary" (click)="applyFilter('filter')">Apply</a>
                </div>
            </div>
        </div>
        <div class="modal-content" fxLayout="column" fxFlex="calc(100% - 100px)">
            <ng-container [ngTemplateOutlet]="modalBoxFilterValues.tp"
                [ngTemplateOutletContext]="{ items: modalBoxFilterValues }"></ng-container>
        </div>
    </div>
</div>

<ng-template #dataSelectorTemplate let-item="item">
    <div class="filter-group" fxLayout="column" *ngIf="showFilter(item.id)">
        <div class="filter-value-selection" (click)="showPopup(item)">
            {{ item.value }}
        </div>
        <div class="count-wrapper">
            <span class="count" (click)="showPopup(item)">{{
                getCount(item.id)
                }}</span>
        </div>
        <div class="help-wrapper">
            <span class="help" appHelpContent [(helpContent)]="helpContent[item.id]">?</span>
        </div>
    </div>
</ng-template>

<ng-template #sliderTemplate let-item="item">
    <div class="filter-group" fxLayout="column" *ngIf="showFilter(item.id) && resetSlider">
        <h6 class="slider-title">
            {{ item.value }}
            <span class="help" appHelpContent [helpContent]="helpContent['samplingDepth']">?</span>
        </h6>
        <div multiHandleRangeSlider [(defaultValues)]="defaultValues" [(relevantValues)]="relevantValues"
            [(newSelectionValues)]="newSelectionValues" [(oldSelectionValues)]="oldSelectionValues"
            [(reset)]="resetSlider" name="range-slider" (onSlidingEvent)="applySliderValue($event)"></div>
    </div>
</ng-template>

<ng-template #filterValuesListTemplate let-items="items">
    <div *ngIf="items.values.multiColumns" class="list-group" fxLayout="row wrap">
        <div fxLayout="column" class="list-group-item" [fxFlex]="items.flexWidth"
            *ngFor="let data of items.values.data">
            <div *ngFor="let item of data" [hidden]="item.isHidden">
                <div [ngClass]="{ 'list-group-panel': items.parentChild }">
                    <!-- Parent Checkbox -->
                    <input type="checkbox" [disabled]="item.isDisabled" [indeterminate]="item.isIndeterminate"
                        [(ngModel)]="item.isSelected" name="list_name" id="parent-{{ item.id }}" value="{{ item.id }}"
                        (ngModelChange)="parentCheck(item)" />
                    <label class="blue-background" for="parent-{{ item.id }}"></label>
                    <div class="check-item" [ngClass]="{ 'label-disabled': item.isDisabled }">
                        {{ item.value }}
                    </div>
                    <!-- Parent Arrow -->
                    <span class="arrow-wrapper" (click)="expandCollapse(item)" *ngIf="items.parentChild">
                        <i class="fas fa-angle-down" *ngIf="item.isClosed; else isCollapsed"></i>
                        <ng-template #isCollapsed>
                            <i class="fas fa-angle-up"></i>
                        </ng-template>
                    </span>
                </div>
                <div class="child-list" [hidden]="item.isClosed">
                    <ul class="list-group level-two">
                        <!-- Child Item -->
                        <li class="list-group-item level-two" *ngFor="let itemChild of item.childList"
                            [hidden]="itemChild.isHidden">
                            <!-- Child Checkbox -->
                            <input type="checkbox" [disabled]="itemChild.isDisabled" [(ngModel)]="itemChild.isSelected"
                                name="list_name_child" id="child-{{ itemChild.id }}" value="{{ itemChild.id }}"
                                (ngModelChange)="
                                    childCheck(item, item.childList)
                                " />
                            <label class="blue-background" for="child-{{ itemChild.id }}"></label>
                            <div class="check-item" [ngClass]="{
                                    'label-disabled': itemChild.isDisabled
                                }">
                                {{ itemChild.value }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!items.values.multiColumns" class="list-group" fxLayout="row wrap">
        <!-- Parent Item -->
        <div fxLayout="column" class="list-group-item" [fxFlex]="items.flexWidth" *ngFor="let item of items.values.data"
            [hidden]="item.isHidden">
            <div [ngClass]="{ 'list-group-panel': items.parentChild }">
                <!-- Parent Checkbox -->
                <input type="checkbox" [disabled]="item.isDisabled" [indeterminate]="item.isIndeterminate"
                    [(ngModel)]="item.isSelected" name="list_name" id="{{ item.id }}" value="{{ item.id }}"
                    (ngModelChange)="parentCheck(item)" />
                <label class="blue-background" for="{{ item.id }}"></label>
                <div class="check-item" [ngClass]="{ 'label-disabled': item.isDisabled }">
                    {{ item.value }}
                </div>
                <!-- Parent Arrow -->
                <span class="arrow-wrapper" (click)="expandCollapse(item)" *ngIf="items.parentChild">
                    <i class="fas fa-angle-down" *ngIf="item.isClosed; else isCollapsed"></i>
                    <ng-template #isCollapsed>
                        <i class="fas fa-angle-up"></i>
                    </ng-template>
                </span>
            </div>
            <div class="child-list" [hidden]="item.isClosed">
                <ul class="list-group level-two">
                    <!-- Child Item -->
                    <li class="list-group-item level-two" *ngFor="let itemChild of item.childList"
                        [hidden]="itemChild.isHidden">
                        <!-- Child Checkbox -->
                        <input type="checkbox" [disabled]="itemChild.isDisabled" [(ngModel)]="itemChild.isSelected"
                            name="list_name_child" id="{{ itemChild.id }}" value="{{ itemChild.id }}"
                            (ngModelChange)="childCheck(item, item.childList)" />
                        <label class="blue-background" for="{{ itemChild.id }}"></label>
                        <div class="check-item" [ngClass]="{
                                'label-disabled': itemChild.isDisabled
                            }">
                            {{ itemChild.value }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>

<div id="container" *ngIf="showDialog" class="display-dialog">
    <div class="dialog">
        <div *ngComponentOutlet="activeComponent"></div>
    </div>
</div>
